import React, { useMemo } from "react";
import { cn } from "@fmc-digital/ui";
import { PasswordRequirementIndicator } from "../../atoms/PasswordRequirementIndicator";
import {
  passwordRequirementListStyles,
  passwordRequirementListHeadingStyles,
  passwordRequirementListItemsStyles,
} from "./password-requirement-list.styles";
import { getPasswordRequirements } from "./password-requirement-list.utils";
import type { PasswordRequirementListProps } from "./password-requirement-list.types";

/**
 * PasswordRequirementList Molecule
 * Combines multiple PasswordRequirementIndicator atoms
 * Displays "Password Requirements" heading and container with light grey background
 */
export const PasswordRequirementList: React.FunctionComponent<
  PasswordRequirementListProps
> = ({ password, email, lastName, className, testId }) => {
  const requirements = useMemo(
    () => getPasswordRequirements(email, lastName),
    [email, lastName]
  );

  return (
    <div
      className={cn(passwordRequirementListStyles(), className)}
      data-testid={testId ?? "password-requirement-list"}
    >
      <h3
        className={cn(passwordRequirementListHeadingStyles())}
        data-testid={`${testId ?? "password-requirement-list"}-heading`}
      >
        Password Requirements
      </h3>
      <div
        className={cn(passwordRequirementListItemsStyles())}
        data-testid={`${testId ?? "password-requirement-list"}-items`}
      >
        {requirements.map((requirement) => {
          const isMet = requirement.validator(password ?? "");
          return (
            <PasswordRequirementIndicator
              key={requirement.id}
              requirement={requirement.label}
              isMet={isMet}
              testId={`${testId ?? "password-requirement-list"}-${requirement.id}`}
            />
          );
        })}
      </div>
    </div>
  );
};
